// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GraphqlTag from "graphql-tag";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as Trophy$LiteracyplanetClientSxEntry from "../Trophy.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as AcademyFragments$LiteracyplanetClientSxEntry from "./AcademyFragments.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyMatrixAggregatesQuery($params: AcademyMatrixInput!)  {\nacademyMatrixAggregates(params: $params)  {\n...AcademyMatrixAggregateFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixAggregateFragment.query);

function parse(value) {
  var value$1 = value.academyMatrixAggregates;
  return {
          academyMatrixAggregates: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixAggregateFragment.verifyArgsAndParse("AcademyMatrixAggregateFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.academyMatrixAggregates;
  var academyMatrixAggregates = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixAggregateFragment.serialize(value);
      });
  return {
          academyMatrixAggregates: academyMatrixAggregates
        };
}

function serializeInputObjectAcademyMatrixInput(inp) {
  var a = inp.accuracyKind;
  var a$1 = inp.locale;
  var a$2 = inp.blacklists;
  var a$3 = inp.classId;
  var a$4 = inp.startDate;
  var a$5 = inp.endDate;
  var a$6 = inp.limit;
  var a$7 = inp.offset;
  var a$8 = inp.mode;
  return {
          categoryId: inp.categoryId,
          accuracyKind: a === "question" ? "question" : "response",
          userId: inp.userId,
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          blacklists: a$2.map(function (b) {
                return b;
              }),
          classId: a$3 !== undefined ? a$3 : undefined,
          startDate: a$4 !== undefined ? a$4 : undefined,
          endDate: a$5 !== undefined ? a$5 : undefined,
          limit: a$6 !== undefined ? a$6 : undefined,
          offset: a$7 !== undefined ? a$7 : undefined,
          mode: a$8 === "lp" ? "lp" : (
              a$8 === "admin" ? "admin" : (
                  a$8 === "student" ? "student" : "teacher"
                )
            )
        };
}

function serializeVariables(inp) {
  return {
          params: serializeInputObjectAcademyMatrixInput(inp.params)
        };
}

function makeVariables(params, param) {
  return {
          params: params
        };
}

function makeInputObjectAcademyMatrixInput(categoryId, accuracyKind, userId, locale, blacklists, classId, startDate, endDate, limit, offset, mode, param) {
  return {
          categoryId: categoryId,
          accuracyKind: accuracyKind,
          userId: userId,
          locale: locale,
          blacklists: blacklists,
          classId: classId,
          startDate: startDate,
          endDate: endDate,
          limit: limit,
          offset: offset,
          mode: mode
        };
}

var AcademyMatrixAggregatesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectAcademyMatrixInput: serializeInputObjectAcademyMatrixInput,
  makeVariables: makeVariables,
  makeInputObjectAcademyMatrixInput: makeInputObjectAcademyMatrixInput
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var AcademyMatrixAggregatesQuery = {
  AcademyMatrixAggregatesQuery_inner: AcademyMatrixAggregatesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectAcademyMatrixInput: serializeInputObjectAcademyMatrixInput,
  makeVariables: makeVariables,
  makeInputObjectAcademyMatrixInput: makeInputObjectAcademyMatrixInput,
  use: use,
  useFetch: useFetch
};

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function use$1(userId) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  var $$fetch = Q.useAsync();
  return async function (startDateOpt, startDateOpt$1, endDateOpt, limitOpt, offsetOpt, classIdOpt, blacklistsOpt, accuracyKindOpt, modeOpt, categoryId) {
    var startDate = startDateOpt$1 !== undefined ? Caml_option.valFromOption(startDateOpt$1) : undefined;
    var endDate = endDateOpt !== undefined ? Caml_option.valFromOption(endDateOpt) : undefined;
    var limit = limitOpt !== undefined ? Caml_option.valFromOption(limitOpt) : undefined;
    var offset = offsetOpt !== undefined ? Caml_option.valFromOption(offsetOpt) : undefined;
    var classId = classIdOpt !== undefined ? Caml_option.valFromOption(classIdOpt) : undefined;
    var blacklists = blacklistsOpt !== undefined ? blacklistsOpt : [];
    var accuracyKind = accuracyKindOpt !== undefined ? accuracyKindOpt : "response";
    var mode = modeOpt !== undefined ? modeOpt : "student";
    return Belt_Option.map(await $$fetch({
                    params: {
                      categoryId: categoryId,
                      accuracyKind: accuracyKind,
                      userId: userId,
                      locale: locale,
                      blacklists: blacklists,
                      classId: classId,
                      startDate: startDate,
                      endDate: endDate,
                      limit: limit,
                      offset: offset,
                      mode: mode
                    }
                  }), (function (q) {
                  return Belt_Array.reduce(q.academyMatrixAggregates, undefined, (function (m, r) {
                                return Belt_Array.reduce(r.categoryAggregates, m, (function (m, a) {
                                              var uniqueActivityCount = a.uniqueActivityCount;
                                              return Belt_MapString.set(m, AcademyParallaxTypes$LiteracyplanetClientSxEntry.makeMatrixKey(r.studentId, a.categoryId), {
                                                          loading: false,
                                                          avgBestCategoryAttempts: a.avgBestCategoryAttempts,
                                                          avgLatestCategoryAttempts: a.avgLatestCategoryAttempts,
                                                          totalCategoryAttempts: a.totalCategoryAttempts,
                                                          uniqueActivityCount: a.uniqueActivityCount,
                                                          totalActivityCount: a.totalActivityCount,
                                                          progress: uniqueActivityCount !== undefined ? AcademyParallaxTypes$LiteracyplanetClientSxEntry.calcPercent(uniqueActivityCount, a.totalActivityCount) : 0,
                                                          trophy: Belt_Option.map(a.avgLatestCategoryAttempts, Trophy$LiteracyplanetClientSxEntry.scoreToTrophy)
                                                        });
                                            }));
                              }));
                }));
  };
}

var AcademyMatrixAggregateFragment;

export {
  AcademyMatrixAggregateFragment ,
  AcademyMatrixAggregatesQuery ,
  Q ,
  use$1 as use,
}
/* query Not a pure module */
